import { CallApi, handleJSONResponse } from './common';
import { GetCatalogQueryParams } from '@services/catalogs/types/api/get-catalog-query';
import CatalogReleaseConnection from '@common/types/catalog/catalog-release-connection';

const callAPI = CallApi('catalogs');

export const list = async (
  params?: Partial<GetCatalogQueryParams>
): Promise<CatalogReleaseConnection> => {
  const urlParams = new URLSearchParams(
    (params as Record<string, string>) || {}
  );

  const response = await callAPI(`/?${urlParams}`, 'GET');
  return (await handleJSONResponse(response)) as CatalogReleaseConnection;
};
